import apiRequest from "@/utils/apiRequest";
import { GET_API_KEYS_URL } from "@/config/apiEndpoints";

import { API_KEY_STATUS_DROPDOWN_OPTIONS } from "@/config";
import convertDate from "@/utils/convertDateToStandard";

export const state = {
  apiKeys: [],
  loading: false,
  selectedApiKey: null,
};
export const getters = {
  apiKeys: (state) => state.apiKeys,
  loading: (state) => state.loading,
  selectedApiKey: (state) => state.selectedApiKey,
};
export const mutations = {
  STORE_API_KEYS(state) {
    state.apiKeys = [];
    state.loading = true;
  },
  STORE_API_KEYS_SUCCESS(state, apiKeys) {
    state.apiKeys = apiKeys;
    state.loading = false;
  },
  STORE_API_KEYS_FAILED(state) {
    state.apiKeys = [];
    state.loading = false;
  },
  SELECT_API_KEY(state, selectedKey) {
    state.selectedApiKey = selectedKey;
  },
};
export const actions = {
  fetchApiKeys({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      apiRequest({
        url: GET_API_KEYS_URL,
        method: "GET",
        params: {
          project_id: projectId,
          type: "p",
        },
      })
        .then((res) => {
          const sortedApiKeys = res.data
            .map((apiKey) => {
              return {
                ...apiKey,
                created_at: convertDate(apiKey.created_at),
                created_at_unconverted: apiKey.created_at,
                updated_at: convertDate(apiKey.updated_at),
                status: API_KEY_STATUS_DROPDOWN_OPTIONS.find(
                  (x) => x.value === apiKey.status
                ),
              };
            })
            .sort((a, b) => {
              return (
                new Date(b.created_at_unconverted) -
                new Date(a.created_at_unconverted)
              );
            });
          commit("STORE_API_KEYS_SUCCESS", sortedApiKeys);
          resolve(sortedApiKeys);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  selectApiKey({ commit }, selectedKey) {
    commit("SELECT_API_KEY", selectedKey);
  },
};
